import React from "react";
import { Modal, Spin, Typography } from "antd";

const { Text } = Typography;

interface RFMGeneratingModalProps {
  visible: boolean;
  message?: string;
}

const RFMGeneratingModal: React.FC<RFMGeneratingModalProps> = ({
  visible,
  message,
}) => {
  return (
    <Modal open={visible} footer={null} closable={false} centered zIndex={9999}>
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spin size="large" />
        <div style={{ marginTop: "20px" }}>
          <Text strong>
            {message || "Generating RFM data, this may take a few minutes..."}
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default RFMGeneratingModal;
